export function notEmptyString(str) {
  return typeof str === 'string' && str;
}

export function notBlankString(str) {
  return notEmptyString(str) && str.trim();
}

/* 删除所有空格 但是要保留回车换行符 所以用空格 不能用\s */
export function removeSpaceChar(val) {
  if (notEmptyString(val)) {
    return val.replace(/[ ]/g, '');
  }
  return val;
}

export function checkNumber(val) {
  const pattern = /^\d+(\.\d+)?$/;
  if (!pattern.exec(val)) {
    return false;
  }
  return true;
}

